import { useAppDispatch } from '../../../../hooks/useAppDispatcher.hook';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { useAppSelector } from '../../../../hooks/useAppSelector.hook';
import { getCandidateRecordsList } from '../../../../redux/Candidate/Record/Record.slice';
import { PersonRecord } from '../../../../redux/Candidate/Record/Record.type';
import { getPersonRecordHistoryLinkThunk } from '../../../../redux/Candidate/Record/History/History.thunk';
import { getCandidateRecordListThunk } from '../../../../redux/Candidate/Record/Record.thunk';
import { RECORDS_PER_PAGE } from '../../../../constants/candidate.constant';
import {
  StyledCandidateRecords,
  StyledCandidateRecordsHeader,
  StyledCandidateRecordsHeaderTitle,
} from '../Candidate.styled';
import CheckboxComponent from '../../../../components/Input/Checkbox.component';
import InfiniteScroll from 'react-infinite-scroll-component';
import SpinnerComponent from '../../../../components/Spinner.component';
import CandidateRecordBlockComponent from '../../../../components/Blocks/CandidateRecordBlock.component';
import NoResultComponent from '../../../../components/NoResult.component';

export const CandidateRecords = ({ candidateId }: { candidateId: string }) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [showAllRecordHistory, setShowAllRecordHistory] = useState(false);

  const { items: candidateRecords, pagination } = useAppSelector(
    getCandidateRecordsList,
  );

  useEffect(() => {
    if (candidateRecords.length) {
      const recordsIds = candidateRecords.map((item: PersonRecord) => item.id);
      fetchHistory(recordsIds, candidateId);
    }
  }, [candidateRecords]);

  async function fetchHistory(records: string[], personId: string) {
    for (const record of records) {
      await dispatch(
        // TODO: rename to `getRecordsHistoryThunk`
        getPersonRecordHistoryLinkThunk({
          personId,
          records: [record],
        }),
      );
    }
  }

  useEffect(() => {
    dispatch(
      getCandidateRecordListThunk({
        personId: candidateId,
        perPage: RECORDS_PER_PAGE,
      }),
    );
  }, [candidateId, dispatch]);

  const hasMoreRecordsToLoad = pagination.currentPage < pagination.lastPage;

  const loadMoreRecords = () => {
    dispatch(
      getCandidateRecordListThunk({
        personId: candidateId,
        page: pagination.currentPage + 1,
        perPage: RECORDS_PER_PAGE,
      }),
    );
  };

  return (
    <StyledCandidateRecords id="scrollableDiv">
      <StyledCandidateRecordsHeader>
        <StyledCandidateRecordsHeaderTitle>
          {t('Person Records')}
        </StyledCandidateRecordsHeaderTitle>
        <div style={{ margin: '10px' }}>
          <CheckboxComponent
            selected={showAllRecordHistory}
            description={t('Show record history')}
            handleChange={() => setShowAllRecordHistory(!showAllRecordHistory)}
          />
        </div>
      </StyledCandidateRecordsHeader>
      {candidateRecords.length > 0 ? (
        <InfiniteScroll
          dataLength={candidateRecords.length}
          next={loadMoreRecords}
          hasMore={hasMoreRecordsToLoad}
          loader={
            <div>
              <SpinnerComponent size="medium" />
            </div>
          }
          scrollableTarget="scrollableDiv"
        >
          {candidateRecords.map((record: PersonRecord) => {
            return (
              <CandidateRecordBlockComponent
                key={record.id}
                info={record}
                showHistory={showAllRecordHistory}
                deleteWithCandidate={candidateRecords.length === 1}
              />
            );
          })}
        </InfiniteScroll>
      ) : (
        <NoResultComponent />
      )}
    </StyledCandidateRecords>
  );
};
